export var ACTION;
(function (ACTION) {
    ACTION["ABOUT"] = "ABOUT";
    ACTION["PROFILE"] = "PROFILE";
    ACTION["BACK_BUTTON"] = "BACK_BUTTON";
    ACTION["GO_TO_PRIVACY"] = "GO_TO_PRIVACY";
    ACTION["GO_TO_TERMS"] = "GO_TO_TERMS";
    ACTION["LENDING_PARTNER"] = "LENDING_PARTNER";
    ACTION["PRODUCT_DETAILS"] = "PRODUCT_DETAILS";
})(ACTION || (ACTION = {}));
